import { computed, ref } from 'vue';
import type { Tourflow } from '@aviata/platform-types';

export const useTownsTo = (
  townsToList: Tourflow.TownTo[],
  initialTownsTo: Tourflow.TownTo[] | null,
) => {
  const textSearchQuery = ref('');
  const selectedTowns = ref<Tourflow.TownTo[]>(
    initialTownsTo?.length ? initialTownsTo : townsToList,
  );

  const isAllSelected = computed(
    () =>
      townsToList.length === selectedTowns.value.length ||
      townsToList.length === 0,
  );

  const filteredByTextSearchQueryTowns = computed(() =>
    townsToList.filter(town =>
      town.name.toLowerCase().includes(textSearchQuery.value.toLowerCase()),
    ),
  );

  const onInputTextSearchQuery = (value: string) => {
    textSearchQuery.value = value;
  };

  const onTownsToSelect = (updatedTownsTo: Tourflow.TownTo[]) => {
    selectedTowns.value = updatedTownsTo;
  };

  const onTownUnselect = (unselectedTownTo: Tourflow.TownTo[]) => {
    const unselectedTownToIds = unselectedTownTo.map(town => town.id);

    selectedTowns.value =
      selectedTowns.value.filter(
        townTo => !unselectedTownToIds.includes(townTo.id),
      ) ?? [];
  };

  const isTownSelected = (townId: number) => {
    return (
      Boolean(selectedTowns.value.map(town => town.id).includes(townId)) ||
      isAllSelected.value
    );
  };

  /**
   * @description We need to send an empty array to backend when all towns are selected
   */
  const getTownsToForSubmit = () => {
    if (isAllSelected.value) {
      return [];
    }

    return selectedTowns.value;
  };

  return {
    selectedTowns,
    textSearchQuery,
    filteredByTextSearchQueryTowns,
    isAllSelected,
    onInputTextSearchQuery,
    onTownsToSelect,
    onTownUnselect,
    isTownSelected,
    getTownsToForSubmit,
  };
};
